// extracted by mini-css-extract-plugin
export default {"Stack":"webpack-system-base-Stack-module__Stack"};